import React from 'react';
import { DateTime } from 'luxon';

const ProductCasual = ({ job }) => {

    const deliveryDate = DateTime.fromISO(job.dateOfFirstAction).toFormat("dd LLL yyyy");
    const removalDate = DateTime.fromISO(job.dateOfSecondAction).toFormat("dd LLL yyyy");

    return (
        <tr>
            <td className="text-left py-3">
                <div>
                    <div className="text-gray-700">
                        {job.binDetails.name} <span className="text-sm font-light text-gray-500">x{job.binDetails.quantity}</span>
                    </div>
                    <div className="text-sm font-light text-gray-500">
                        Delivery: {deliveryDate}
                    </div>
                    {job.dateOfSecondAction ?
                    <div className="text-sm font-light text-gray-500">
                        Removal: {removalDate}
                    </div> : null
                    }
                </div>
            </td>
            <td className="px-3 text-gray-700 align-top pt-3">
                ${job.binDetails.price}
            </td>
            <td className="px-3 text-gray-700 align-top pt-3">
                ${job.price}
            </td>
        </tr>
    )
}

export default ProductCasual;